import { useEffect, useMemo, useState } from "react"
import { Form, InputGroup, Modal, OverlayTrigger, Tooltip, Button } from "react-bootstrap"
import styles from './style.module.css'

export default function CheckPrice({ onHide, currentReceipt }) {
    const [file, setFile] = useState('');
    const [check, setCheck] = useState();
    const [copySuccess, setCopySuccess] = useState('');

    useEffect(() => {
        if (currentReceipt != '') setCheck(JSON.parse(currentReceipt));
        if (!file)
            return;

        setCheck(JSON.parse(file));
    }, [file, currentReceipt]);

    const copyCheckToClipboard = () => {
        if (!check) return;

        let checkText = ``;

        // Стандартные товары
        check.products.forEach((p, index) => {
            if (p.sizeUser == -1 || p.thicknessUser == -1) checkText += `${index + 1}. ${p.name}\n`;
            else checkText += `${index + 1}. ${p.name} ${p.sizeUser}мм х ${p.thicknessUser}мм\n`;

            if (p.discountsPercent && p.discountsPercent.length > 0) {
                p.discountsPercent.forEach(ad => {
                    if (ad.percent > 0)
                        checkText += `Скидка: ${ad.percent}%\n`;
                });
            }

            if (p.discountsValue && p.discountsValue.length > 0) {
                p.discountsValue.forEach(ad => {
                    if (ad.value > 0)
                        checkText += `Скидка: ${ad.value}₽\n`;
                });
            }

            checkText += `Кол-во: ${p.selfCount}шт.\n`;
            checkText += `Цена за шт.: ${p.priceSelf}₽\n`;
            checkText += `Итого: ${p.priceSumCount}₽\n`;
        });

        // Нестандартные товары
        if (check.customProducts && check.customProducts.length > 0) {
            check.customProducts.forEach((p, index) => {
                checkText += `${check.products.length + index + 1}. ${p.name}\n`;
                checkText += `Кол-во: ${p.count}шт.\n`;
                checkText += `Цена за шт.: ${p.pricePerItem}₽\n`;
                checkText += `Итого: ${p.totalPrice}₽\n`;
            });
        }

        if (check.additions && (check.additions.length - check.additions.filter(ad => ad.name.toLowerCase().includes('скидка')).length) > 0) {
            checkText += "\nДополнения к заказу:\n";
            check.additions.filter(ad => !ad.name.toLowerCase().includes('скидка'))
                .forEach(ad => {
                    if (ad.freeItems > 0) {
                        checkText += `${ad.name}: ${ad.actualPrice}₽`;
                        checkText += `\n`;
                    } else {
                        checkText += `${ad.name}: ${(ad.math == 1 || ad.math == 2 || ad.math == 5 ? ad.value : ad.value * -1) * ad.coefficientValue}${ad.math == 5 || ad.math == 1 || ad.math == 3 ? '₽' : '%'}\n`;
                    }
                });
        }

        if (check.discountProducts?.length > 0) {
            checkText += "Дополнения к заказу (кастом)\n";
            check.discountProducts.forEach(ad => {
                const productsList = ad.products?.map(p => p.name).join(', ');
                checkText += `${ad.name} ${ad.value}${ad.math == 5 || ad.math == 1 ? '₽' : '%'}`;
                if (productsList) {
                    checkText += ` (${productsList})`;
                }
                checkText += '\n';
            });
        }

        checkText += "\nИтого:\n";
        checkText += `Вес заказа: ${check.weightOrder}кг\n`;
        checkText += `Стоимость заказа: ${check.nominalPrice}₽\n`;
        if (check.travelPrice != 0) checkText += `Доставка: ${check.travelPrice}₽\n`;
        if (check.additionValuePrice != 0) checkText += `Дополнения: ${check.additionValuePrice || 0}₽\n`;
        if (check.additionPercentPrice != 0) {
            if (check.additionPercentPrice > 0) checkText += 'Надбавка: ';
            else if (check.additionPercentPrice < 0) checkText += 'Скидка: ';
            checkText += `${check.additionPercentPrice || 0}%\n`;
        }
        checkText += `Итого: ${check.sumPrice}₽\n`;
        if (check.ndsPrice != 0) checkText += `В том числе НДС: ${check.ndsPrice}₽\n`;

        navigator.clipboard.writeText(checkText)
            .then(() => {
                setCopySuccess('Чек скопирован в буфер обмена!');
                setTimeout(() => setCopySuccess(''), 3000);
            })
            .catch(err => {
                setCopySuccess('Ошибка копирования: ' + err);
            });
    };

    const content = useMemo(() => {

        if (!check)
            return '';

        return <div>
            <InputGroup className="mb-3">
                <InputGroup.Text>Дата</InputGroup.Text>
                <Form.Control
                    value={new Date(check.date).toLocaleString('ru-RU', {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                    })}
                    readOnly
                />
            </InputGroup>

            {/* Стандартные товары */}
            <div>
                {check.products.map(p => (
                    <div key={p.id}>
                        <div className={styles.tabItemInCheck}>
                            <h4>{(p.sizeUser == -1 && p.thicknessUser == -1) ? p.name : `${p.name} ${p.sizeUser}мм х ${p.thicknessUser}мм`}</h4>

                            {p.discountsPercent && p.discountsPercent.length > 0 && (
                                <div className={styles.borderTop}>
                                    {p.discountsPercent.map(ad => (
                                        <div key={ad.id} className={styles.productPriceItem}>
                                            <span className={styles.price_name}>Скидка в % {ad.percent}%</span>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {p.discountsValue && p.discountsValue.length > 0 && (
                                <div className={styles.borderTop}>
                                    {p.discountsValue.map(ad => (
                                        <div key={ad.id} className={styles.productPriceItem}>
                                            <span className={styles.price_name}>Скидка в ₽ {ad.value}₽</span>
                                        </div>
                                    ))}
                                </div>
                            )}

                            <div className={styles.productPriceItem}>
                                <span className={styles.price_name}>Кол-во {p.selfCount}шт.</span>
                            </div>

                            <div className={styles.productPriceItem}>
                                <span className={styles.price_name}>Цена шт. {p.priceSelf}₽</span>
                            </div>

                            <div className={styles.productPriceItemSum}>
                                <span className={styles.price_name}>Итого {p.priceSumCount}₽</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Нестандартные товары */}
            {check.customProducts && check.customProducts.length > 0 && (
                <div>
                    <h4>Нестандартные товары</h4>
                    {check.customProducts.map(p => (
                        <div key={p.id} className={styles.tabItemInCheck}>
                            <h4>{p.name}</h4>

                            <div className={styles.productPriceItem}>
                                <span className={styles.price_name}>Кол-во {p.count}шт.</span>
                            </div>

                            <div className={styles.productPriceItem}>
                                <span className={styles.price_name}>Цена за шт. {p.pricePerItem}₽</span>
                            </div>

                            <div className={styles.productPriceItem}>
                                <span className={styles.price_name}>Вес за шт. {p.weightPerItem}гр.</span>
                            </div>

                            <div className={styles.productPriceItemSum}>
                                <span className={styles.price_name}>Итого {p.totalPrice}₽</span>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <div className={styles.tabItemInCheck}>
                {check.additions && (check.additions.length - check.additions.filter(ad => ad.name.toLowerCase().includes('скидка')).length) > 0 && (
                    <div>
                        <h4>Дополнения к заказу</h4>
                        {check.additions.filter(ad => !ad.name.toLowerCase().includes('скидка'))
                            .map(ad => (
                                <div key={ad.id} className={styles.productPriceItem}>
                                    <span className={styles.price_name}>
                                        {ad.freeItems > 0 ? `${ad.name} ${ad.actualPrice}₽` :
                                            `${ad.name} ${(ad.math == 1 || ad.math == 2 || ad.math == 5 ? ad.value : ad.value * -1) * ad.coefficientValue}
                                            ${ad.math == 1 || ad.math == 3 || ad.math == 5 ? '₽.' : '%'}`
                                        }
                                    </span>
                                </div>
                            ))}
                    </div>
                )}
            </div>

            <div className={styles.tabItemInCheck}>
                {check.discountProducts && check.discountProducts.length > 0 && (
                    <div>
                        <h4>Дополнения к заказу (кастом)</h4>
                        {check.discountProducts.map(ad => (
                            <div key={ad.id} className={styles.productPriceItem}>
                                <span className={styles.price_name}>
                                    <OverlayTrigger overlay={
                                        <Tooltip id={`addition-in-order-custom-check-tooltip-${ad.id}`}>
                                            {ad.products?.map(map => map.name).join(', ')}
                                        </Tooltip>
                                    }>
                                        <span>{ad.name} {ad.value}{ad.math == 5 || ad.math == 1 ? '₽' : '%'}</span>
                                    </OverlayTrigger>
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <div className={styles.tabItemInCheck}>
                <h4>Итого</h4>
                <div className={styles.productPriceItem}>
                    <span className={styles.price_name}>Вес заказа {check.weightOrder}кг</span>
                </div>
                <div className={styles.productPriceItem}>
                    <span className={styles.price_name}>Стоимость заказа {check.nominalPrice}₽</span>
                </div>
                {check.travelPrice != 0 && (
                    <div className={styles.productPriceItem}>
                        <span className={styles.price_name}>Доставка {check.travelPrice}₽</span>
                    </div>
                )}
                {check.additionValuePrice != 0 && (
                    <div className={styles.productPriceItem}>
                        <span className={styles.price_name}>Дополнения {check.additionValuePrice}₽</span>
                    </div>
                )}
                {check.additionPercentPrice != 0 && (
                    <div className={styles.productPriceItem}>
                        {check.additionPercentPrice > 0 ?
                            <span className={styles.price_name}>Надбавка {check.additionPercentPrice}%</span>
                            :
                            <span className={styles.price_name}>Скидка {check.additionPercentPrice}%</span>
                        }
                    </div>
                )}
                <div className={styles.productPriceItemSum}>
                    <span className={styles.price_name}>Итого {check.sumPrice}₽</span>
                </div>
                {check.ndsPrice != 0 && (
                    <div className={styles.productPriceItem}>
                        <span className={styles.price_name}>В том числе НДС {check.ndsPrice}₽</span>
                    </div>
                )}
            </div>
        </div>

    }, [check]);

    return <Modal show={true} onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
    >
        <Modal.Header closeButton>
            <Modal.Title>Просмотр чека {check?.version}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form.Control
                type={'file'}
                accept=".json"
                className="mb-3"
                onChange={(e) => {
                    const reader = new FileReader();
                    reader.onload = (e) => setFile(e.target.result);
                    reader.readAsText(e.target.files[0]);
                }}
            />

            <Button
                variant="primary"
                onClick={copyCheckToClipboard}
                className="mb-3"
            >
                Копировать чек
            </Button>

            {copySuccess && <div className="alert alert-success">{copySuccess}</div>}

            {content}
        </Modal.Body>
    </Modal>
}